import { z } from 'zod/v3';

export const systemPickerValueSchema = z.string();

export const systemPickerUiOptionsSchema = z.object({
  /**
   * Name of the sibling template parameter holding the selected Domain
   * entity ref. Defaults to "domain".
   */
  domainField: z.string().optional(),
});

export type SystemPickerValue = z.infer<typeof systemPickerValueSchema>;
export type SystemPickerUiOptions = z.infer<
  typeof systemPickerUiOptionsSchema
>;
